import { repositoryActions, service } from '..';

export const selectorsService = {
  get: () => service( 'selector' ).get().then( response => ( { type: repositoryActions( 'selector' ).RETRIEVED, items: response.data } ) )
};